import React, { useMemo } from "react";
import {
    AccountClass,
    BalanceSheetAccountClass,
} from "@common/constants/domains/accounting/accounts";
import { BaseCellProps } from "./index";
import { DropdownCell } from "./DropdownCell";

interface AccountClassCellProps extends BaseCellProps<string> {
    balanceSheetClassesOnly?: boolean;
}

export const AccountClassCell: React.FC<AccountClassCellProps> = ({
    balanceSheetClassesOnly,
    ...props
}) => {
    const options = useMemo(() => {
        const classes = balanceSheetClassesOnly
            ? Object.values(BalanceSheetAccountClass)
            : Object.values(AccountClass);
        return classes.map((value) => ({ value, label: value }));
    }, [balanceSheetClassesOnly]);

    return <DropdownCell {...props} options={options} />;
};
